import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({

    boldText: {
        fontWeight: 'bold',
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    },
}));

const ThongTinCongTy = () => {
    const classes = useStyles();


    return (
        <Box>
            <Typography component="span" className={classes.boldText}>
                Mọi chi tiết xin liên hệ:
            </Typography>
            <br />
            <Typography component="span" className={classes.boldText}>
                CÔNG TY CỔ PHẦN Ô TÔ TNF
            </Typography>
            <br />
            <Typography variant="body1" ><Typography component="span" className={classes.boldText}>Địa chỉ:</Typography>  Đường Cách Mạng Tháng Tám, Tổ 3, Phường Cam Giá, Thành phố Thái Nguyên, tỉnh Thái  Nguyên, Việt Nam</Typography>
            <Typography variant="body1" ><Typography component="span" className={classes.boldText}>Điện thoại:</Typography> 0966.122.815</Typography>
            <Typography variant="body1" ><Typography component="span" className={classes.boldText}>Email:</Typography> minhquanhh99@gmail.com</Typography>
            <Typography variant="body1" ><Typography component="span" className={classes.boldText}>Fanpage:</Typography> https://www.facebook.com/profile.php?id=61576031008836</Typography>
        </Box>
    );
};

export default ThongTinCongTy;